var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonitor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EEA0B6"
    },
    cx: 256,
    cy: 115.341,
    r: 115.341
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#20AAB0"
    },
    d: "M371.341,149.099H140.659c-18.644,0-33.758-15.115-33.758-33.758s15.115-33.758,33.758-33.758 h230.681c18.644,0,33.758,15.115,33.758,33.758S389.984,149.099,371.341,149.099z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DA5B82"
    },
    d: "M256,194.11c-7.556,0-15.034-1.059-22.224-3.149c-4.476-1.3-7.051-5.982-5.75-10.459 c1.301-4.475,5.985-7.05,10.458-5.749c11.321,3.288,23.714,3.288,35.031,0c4.476-1.302,9.16,1.274,10.459,5.749 c1.3,4.475-1.274,9.16-5.749,10.459C271.034,193.051,263.557,194.11,256,194.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0DDDF"
    },
    d: "M275.692,282.435L256,304.105l-19.692-21.671c-36.643,3.104-70.844,14.78-100.583,33.03L256,474.681 c0,0,120.275-159.216,120.275-159.229C346.536,297.214,312.336,285.538,275.692,282.435z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#06484A"
    },
    points: "236.308,315.358 223.549,493.179 288.451,493.179 275.692,315.358 256,303.017 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#086063"
    },
    d: "M275.692,282.435c-6.492-0.55-13.059-0.835-19.692-0.835c-6.633,0-13.201,0.286-19.692,0.835v32.923 h39.385V282.435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#14858A"
    },
    d: "M376.281,315.461L256,435.741L135.719,315.461C69.667,355.971,25.6,428.835,25.6,512h460.8 C486.4,428.835,442.333,355.971,376.281,315.461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#086063"
    },
    d: "M337.582,123.78H174.418c-4.661,0-8.44-3.778-8.44-8.44s3.779-8.44,8.44-8.44h163.165 c4.662,0,8.44,3.778,8.44,8.44S342.244,123.78,337.582,123.78z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.d63a3e41179a4b232aa7a46043d09102.svg";
export { ForwardRef as ReactComponent };